import api from "lib/api";

export const getNotificationTemplateById = async (params = {}) => {
    return await api.post("/v1/emailTemplateSetting/getEmailTemplateSetting", params);
};

export const getDropdownTemplateById = async (params = {}) => {
    return await api.post("/v1/dropdown/getEmailTemplateSetting", params);
};


export const updateNotificationTemplateById = async (params = {}) => {
    return await api.post("/v1/emailTemplateSetting/updateEmailTemplateSetting", params);
};